import React, { useState, useEffect } from 'react';
import { ADGMTextField, ADGMModal, ADGMImage, ADGMSnackbar, Loading } from 'aurora-components';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import { postSurveyFeedback } from 'aurora-composition/modules/common/actions';
import { keyEmptyCheck } from 'aurora-utils/utils';
import * as types from 'aurora-composition/modules/common/constants';
import { useSelector, useDispatch } from 'react-redux';

import styles from './styles';

const HappinessMeter = ({ classes, applicationNumber, applicationId, applicationType }) => {
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [rating, setRating] = useState('');
  const [comment, setComment] = useState('');
  const dispatch = useDispatch();
  const [{ feedbackAppId, loading, error, feedbackAdded }, { user }] = useSelector(stateReducer => [
    stateReducer.commonReducer,
    stateReducer.userReducer,
  ]);

  const toggleFeedbackModal = () => {
    setOpenFeedbackModal(!openFeedbackModal);
  };
  const toggleSuccessModal = () => {
    setOpenSuccessModal(!openSuccessModal);
    dispatch({ type: types.HAPPINESS_METER_UPDATE_FLAG });
  };
  useEffect(() => {
    if (feedbackAdded) {
      setOpenFeedbackModal(false);
      toggleSuccessModal();
    }
    if (applicationId !== feedbackAppId) {
      setTimeout(() => {
        setOpenFeedbackModal(true);
      }, 3000);
    }
    if (error) {
      setOpenFeedbackModal(true);
    }
    return () => {
      setOpenFeedbackModal(false);
    };
  }, [feedbackAdded, error]);
  const submitFeedback = () => {
    const ratingProvided = rating === 'happy' ? 10 : rating === 'neutral' ? 8 : 6;
    dispatch(
      postSurveyFeedback({ ratingProvided, comment, applicationNumber, applicationId, applicationType, user }),
    ).then(() => {
      toggleFeedbackModal();
    });
  };

  return (
    <>
      <ADGMModal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={openFeedbackModal}
        // toggleModal={toggleModalReject}
        onClose={toggleFeedbackModal}
        className={classes.happyMeterModal}
      >
        <Box display='flex' justifyContent='space-between' className={classes.modalHeading}>
          {error && <ADGMSnackbar message={error} />}
          {loading && <Loading />}
          <Typography variant='h6' component='h1' className={classes.modalTitle}>
            {keyEmptyCheck('rating_service_flow', { s: keyEmptyCheck(applicationType) })}
          </Typography>
          <ADGMImage
            name='cross-icon-black.svg'
            alt='crossicon'
            className={classes.crossIconImg}
            aria-hidden='true'
            onClick={toggleFeedbackModal}
          />
        </Box>
        <Box display='flex' justifyContent='space-between' className={classes.modalHeading}>
          <div className={classes.emojiCls}>
            {rating === 'sad' ? (
              <ADGMImage name='sadSelected.svg' alt='sad' aria-hidden='true' onClick={() => setRating('')} />
            ) : (
              <ADGMImage name='sad.svg' alt='sad' aria-hidden='true' onClick={() => setRating('sad')} />
            )}
            <Typography variant='subtitle1' component='h6' className={classes.emojiTxt}>
              {keyEmptyCheck('sad')}
            </Typography>
          </div>
          <div className={classes.emojiCls}>
            {rating === 'neutral' ? (
              <ADGMImage name='neutralSelected.svg' alt='crossicon' aria-hidden='true' onClick={() => setRating('')} />
            ) : (
              <ADGMImage name='neutral.svg' alt='crossicon' aria-hidden='true' onClick={() => setRating('neutral')} />
            )}
            <Typography variant='subtitle1' component='h6' className={classes.emojiTxt}>
              {keyEmptyCheck('neutral')}
            </Typography>
          </div>
          <div className={classes.emojiCls}>
            {rating === 'happy' ? (
              <ADGMImage name='happySelected.svg' alt='crossicon' aria-hidden='true' onClick={() => setRating('')} />
            ) : (
              <ADGMImage name='happy.svg' alt='crossicon' aria-hidden='true' onClick={() => setRating('happy')} />
            )}

            <Typography variant='subtitle1' component='h2' className={classes.emojiTxt}>
              {keyEmptyCheck('happy')}
            </Typography>
          </div>
        </Box>
        {rating && (
          <Box mt={2}>
            <Typography variant='subtitle1' component='h1' className={classes.fontW500}>
              {keyEmptyCheck('place_your_comments')}
            </Typography>
            <ADGMTextField type='textarea' textArea minRows={2} fullWidth onChange={e => setComment(e.target.value)} />
          </Box>
        )}

        <Box display='grid' gridGap='1em' className={classNames(classes.actionsBtnContainer)}>
          <Box>
            <Button variant='outlined' onClick={toggleFeedbackModal}>
              {keyEmptyCheck('discard')}
            </Button>
          </Box>

          <Box>
            <Button
              variant='contained'
              color='primary'
              className={classes.adgmRedBtn}
              disabled={rating === ''}
              onClick={submitFeedback}
            >
              {keyEmptyCheck('submit')}
            </Button>
          </Box>
        </Box>
      </ADGMModal>
      <ADGMModal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={openSuccessModal}
        toggleModal={toggleSuccessModal}
        onClose={toggleSuccessModal}
        className={classes.happyMeterModal}
      >
        <Box display='flex' justifyContent='end'>
          <ADGMImage
            name='cross-icon-black.svg'
            alt='crossicon'
            className={classes.crossIconImg}
            aria-hidden='true'
            onClick={toggleSuccessModal}
          />
        </Box>
        <Box display='flex' justifyContent='center'>
          <ADGMImage name='SuccessApplication.svg' alt='success_icon' width='64' height='64' />
        </Box>
        <Box mt={2} display='flex' justifyContent='center'>
          <Typography variant='subtitle1' component='h1' align='center'>
            {keyEmptyCheck('feedback_thanks')}
          </Typography>
        </Box>
        <Box display='flex' className={classNames(classes.actionsBtnContainer)}>
          <Button variant='contained' color='primary' className={classes.adgmRedBtn} onClick={toggleSuccessModal}>
            {keyEmptyCheck('done')}
          </Button>
        </Box>
      </ADGMModal>
    </>
  );
};
HappinessMeter.propTypes = {
  classes: PropTypes.object.isRequired,
  applicationNumber: PropTypes.string.isRequired,
  applicationId: PropTypes.number.isRequired,
  applicationType: PropTypes.string.isRequired,
};
export default withStyles(styles)(HappinessMeter);
